import { useEffect } from 'react';
import ButtonFilledSmall from '../../components/common/Buttons/ButtonFilledSmall';
import StageCell from '../../components/common/Table/StageCell';
import TableHeaderCell from '../../components/common/Table/TableHeaderCell';
import TablePlainDataCell from '../../components/common/Table/TablePlainDataCell';
import TableTextCell from '../../components/common/Table/TableTextCell';
import { getAllRequests } from '../../utils/api/requestApi';
import { useRequestorStore } from '../../stores/requestorStore';
import { useCommonStore } from '../../stores/commonStore';
import { IRequestInfo, IReqAssigneeItem } from '../../types/requester';
import UserProfileCell from '../../components/common/Table/UserProfileCell';
import { USER } from '../../utils/constants/images';
import { getDateAndTime, getTimeDiff } from '../../utils/commonUtils';
import { useHistory } from 'react-router-dom';
import { Routes } from '../../utils/constants/routes';
import { STAGES, STATUSES } from '../../utils/constants';
import { useAuthStore } from '../../stores/authStore';
import { getLocalActiveRole } from '../../utils/authUtils';

const AllRequests = () => {
    const headerData = ['request ID', 'created at', 'updated at', 'stage', 'action by', ''];
    const setRequests = useRequestorStore((state) => state.setRequests);
    const requests: Array<IRequestInfo> = useRequestorStore((state) => state.requests);
    const history = useHistory();
    const setActiveRequest = useRequestorStore((state) => state.setActiveRequest);
    const activeRole = useAuthStore((state) => state.activeRole);
    const setToastMessage = useCommonStore((state) => state.setToastMessage);

    const handleGetAllRequests = async () => {
        let roleRequested = activeRole;
        if (activeRole === '') {
            const localActiveRole = getLocalActiveRole();
            if (localActiveRole) {
                roleRequested = localActiveRole;
            }
        }
        try {
            const { data } = await getAllRequests(roleRequested);
            setRequests(data);
        } catch (e) {
            setToastMessage({ type: 'error', message: 'Something went wrong' });
            console.error(e);
        }
    };
    const setShowActiveRequest = useRequestorStore((state) => state.setShowActiveRequest);
    const setShowActiveProduct = useRequestorStore((state) => state.setShowActiveProduct);
    const setFlyoutRightOpen = useCommonStore((state) => state.setFlyoutRightOpen);

    const handleViewMore = (index: number) => {
        setActiveRequest(requests[index]);
        setShowActiveProduct(false);
        setShowActiveRequest(true);
        setFlyoutRightOpen(true);
    };
    const handleViewRequest = (id: number, index: number) => {
        setActiveRequest(requests[index]);

        history.push(`${Routes.VENDOR_ROUTES.PRODUCTS}/${id}`);
    };
    const handleRequestBreakDownScreen = (id: number, index: number, assignee: IReqAssigneeItem[] | null) => {
        setActiveRequest(requests[index]);
        history.push(`${Routes.VENDOR_ROUTES.REQUEST_BREAKDOWN}/${id}`, { assigneeInfo: assignee });
    };

    const navigateToCreateQuotation = (id: number) => {
        history.push(`${Routes.OPS_ROUTES.CREATE_QUOTATION.replace(':id', `${id}`)}`);
    };

    useEffect(() => {
        handleGetAllRequests();
    }, []);

    return (
        <div className="container mx-auto p-8 pb-0">
            <div className="pb-1">
                <div className="flex flex-row mb-3 sm:mb-0 justify-between w-full">
                    <h2 className="text-xl font-semibold text-black">All Requests</h2>
                </div>
                <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
                    <div className="inline-block min-w-full shadow-sm rounded-lg overflow-hidden">
                        <table className="min-w-full leading-normal table-auto">
                            <thead>
                                <tr>
                                    {headerData?.map((title) => (
                                        <TableHeaderCell label={title} />
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {requests.map(({ id, createdAt, updatedAt, stage, status, user, assignee }, index) => {
                                    const timeDifference = getTimeDiff(createdAt, new Date());
                                    return (
                                        <tr key={id} className="cursor-pointer" onClick={() => handleViewMore(index)}>
                                            <TableTextCell dataLabel={headerData[0]} label={id} />
                                            <TableTextCell dataLabel={headerData[1]} label={getDateAndTime(createdAt)} />
                                            <TableTextCell dataLabel={headerData[2]} label={getDateAndTime(updatedAt)} />
                                            <StageCell dataLabel={headerData[3]} title={STAGES[stage]} subTitle={STATUSES[status]} activeColor="#5482FF" />
                                            <UserProfileCell dataLabel={headerData[4]} imageUrl={USER} title={user?.username} subTitle={user?.email} />

                                            <TablePlainDataCell dataLabel={headerData[6]}>
                                                <div className="text-right">
                                                    <ButtonFilledSmall
                                                        label="Open"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleRequestBreakDownScreen(id, index, assignee);
                                                        }}
                                                    />
                                                </div>
                                            </TablePlainDataCell>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllRequests;
